// extracted by mini-css-extract-plugin
module.exports = {"offer":"OfferProducts_offer__BqgZe"};